import { cn } from "@/utils/lib";

interface TableLoaderProps {
  className?: string;
}

const TableLoader = ({ className = "" }: TableLoaderProps) => {
  return (
    <div
      className={cn(
        "absolute top-[-3px] h-0.5 w-full overflow-hidden bg-primary",
        className,
      )}
    >
      <div
        className="
          absolute inset-0 h-full animate-[table-loader_1.5s_infinite_linear]
          bg-accent
        "
      ></div>
    </div>
  );
};

export default TableLoader;
